import React from 'react'
import styled from 'styled-components'

import Icon, { IconProps } from './Icon'

/**
 * チェックオフアイコン
 */
const CheckOffIcon: React.FC<IconProps> = (props) => {
  return (
    <IconWrapper {...props}>
      <CustomIcon
        color="var(--color-disabled-text)"
        width={`calc(${props.width} * 54.1%)`}
        height={`calc(${props.height} * 41.6%)`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="10"
          viewBox="0 0 13 10"
        >
          <path
            d="M4.854,7.059,11.3.3a.962.962,0,0,1,1.4,0,1.075,1.075,0,0,1,0,1.47L4.854,10,.291,5.223a1.075,1.075,0,0,1,0-1.47.962.962,0,0,1,1.4,0Z"
            transform="translate(0)"
          />
        </svg>
      </CustomIcon>
    </IconWrapper>
  )
}

const IconWrapper = styled.div<{
  color?: string
  width?: string
  height?: string
}>`
  width: ${(props): string => (props.width ? props.width : '24px')};
  height: ${(props): string => (props.height ? props.height : '24px')};
  line-height: ${(props): string => (props.height ? props.height : '24px')};
  text-align: center;
  background: ${(props): string =>
    props.color ? props.color : 'var(--color-disabled)'};
  border-radius: 50%;
`

const CustomIcon = styled(Icon)`
  position: relative;
  top: -1px;
`

export default CheckOffIcon
